// regexp for number [with minus (only one) and decimal point]

export const numRegExp = /^-?[0-9]\d*(\.\d+)?$/;
